import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const MaxUnfilledBeforeBackfillConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Max Unfilled Before Backfill"
				headingPath={[
					'Dashboard',
					'Framerate',
					'Request Structure Data',
					'Max Unfilled Before Backfill'
				]}
				description="Set the maximum number of unfilled before backfill"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ margin: '4rem 0 0 5rem', width: '93.5%' }}>
				<Grid item xs={3}>
					<InputConfig
						label="Max Unfilled Before Backfill"
						keyData={keyData}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{ min: 0, max: 100 }}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
						onChangeCheck={(inputData) => {
							if (inputData > 100) {
								alert(`Max range : 100`);
								return;
							}
							if (inputData < 0) {
								alert(`Min range : 0`);
								return;
							}
							return true;
						}}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default MaxUnfilledBeforeBackfillConfig;
